// extracted by mini-css-extract-plugin
export default {"overlay":"ConfirmationModal_overlay__Zxb4i","content":"ConfirmationModal_content__2OSXg","buttons":"ConfirmationModal_buttons__ccURM","textarea":"ConfirmationModal_textarea__gejT-"};